import type { FC, ReactNode } from "react";
import { createContext, useContext, useState } from "react";
import { cx } from "shared/utils";
import { Loader } from "shared/components/Loader";

type ContextOptions = {
  loadingText?: string;
  backgroundColorClx?: string;
  loader?: ReactNode;
};

const OverlayContext = createContext<{
  open: boolean;
  setOpen: (v: boolean, ctxOptions?: ContextOptions) => void;
}>({
  open: false,
  setOpen: () => null
});

export const OverlayProvider: FC<{
  children?: ReactNode;
}> = ({ children }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [options, setOptions] = useState<ContextOptions>();

  return (
    <OverlayContext.Provider
      value={{
        open,
        setOpen: (v, ctx) => {
          // TODO: when in the mood combine in reduce state to access prevState instead of v.
          setOptions(v ? ctx : undefined);
          setOpen(v);
        }
      }}
    >
      <div
        className={
          open ? "pointer-events-none max-h-screen overflow-hidden" : ""
        }
      >
        {open ? (
          <div
            className={cx(
              "animate-appear absolute z-[999] flex flex-col gap-4 h-screen w-full items-center justify-center bg-transparent transition-all",
              options?.backgroundColorClx
                ? options.backgroundColorClx
                : "bg-alpha-200"
            )}
          >
            {options?.loader ? options.loader : <Loader />}

            {options?.loadingText ? (
              <p className="text-content-1000 font-medium text-base">
                {options.loadingText}
              </p>
            ) : null}
          </div>
        ) : null}
        {children}
      </div>
    </OverlayContext.Provider>
  );
};

export const useOverlay = () => useContext(OverlayContext);
